// extracted by mini-css-extract-plugin
export default {"overlay":"Notice_overlay__uK3MJ","show":"Notice_show__geA8l","notice":"Notice_notice__poW+g","noticeClose":"Notice_noticeClose__459-Z"};